/**
 *
 * @license
 * Copyright Santander UK. All Rights Reserved.
 * Module is to handle adobe tagging for SBBI and Retail Markets
 */
import { NgModule } from '@angular/core';
import { AdobeAnalyticsScriptService } from './services/adobe-analytics-script.service';
import { AdobeAnalyticsService } from './services/adobe-analytics.service';
@NgModule({
  providers: [AdobeAnalyticsScriptService, AdobeAnalyticsService],
})
export class AdobeAnalyticsModule {}
